import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src3119819440/src/src/templates/markdown-page.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>Terms and conditions applicable to all .mobi registrations</h1>
    <p>
  <a href="/terms-conditions">Back to Terms and Conditions</a>
    </p>
    <p>
  Indemnify to the maximum extent permitted by law, defend and hold harmless
  Registry Operator, and its directors, officers, employees and agents from and
  against any and all claims, damages, liabilities, costs and expenses,
  including reasonable legal fees and expenses, arising out of or relating to
  the Registered Name Holder's domain name registration and or use, and this
  indemnification obligation survive the termination or expiration of the
  registration agreement.
    </p>
    <p>
  Indemnify, defend and hold harmless Registry Services Provider, its
  subsidiaries and affiliates, and the directors, officers, employees and agents
  or each of them, from and against any and all claims, damages, liabilities,
  costs and expenses, including reasonable legal fees and expenses, arising out
  of or relating to the Registered Name Holder's domain name registration and or
  use, and indemnification obligation survive the termination or expiration of
  the registration agreement.
    </p>
    <p>
  Acknowledge and agree that notwithstanding anything in this Agreement to the
  contrary, mTLD Top Level Domain Ltd. ("dotMobi"), the Registry Operator of the
  .mobi TLD, is and shall be an intended third party beneficiary of this
  Agreement. As such, the parties to this Agreement acknowledge and agree that
  the third party beneficiary rights of dotMobi have vested and that dotMobi has
  relied on its third party beneficiary rights under this Agreement in agreeing
  to Registrar being a registrar for the .mobi top-level domain. Additionally,
  the third party beneficiary rights of dotMobi shall survive any termination or
  expiration of this Agreement.
    </p>
    <p>
  Comply with ICANN requirements, standards, policies, procedures, and practices
  for which Registry Operator has monitoring responsibility in accordance with
  the Registry Agreement or other arrangement with ICANN.
    </p>
    <p>
  Comply with operational standards, policies, procedures, and practices for the
  Registry TLD established from time to time by Registry Operator in a
  non-arbitrary manner as Registry Policies, applicable to all registrars and/or
  Registered Name Holders, and consistent with the Registry Agreement shall be
  effective upon thirty days notice by Registry Operator to Registrar.
    </p>
    <p>
  Consent to the use, copying, distribution, publication, modification and other
  processing of Registered Name Holder's Personal Data by Registry Operator and
  its designees and agents in a manner consistent with the purposes specified
  pursuant to Subsection 2.6 and with relevant mandatory local data protection,
  laws and privacy.
    </p>
    <p>
  Submit to proceedings commenced under ICANN's Uniform Domain Name Dispute
  Resolution Policy ("UDRP").
    </p>
    <p>
  Immediately correct and update the registration information for the registered
  Name during the registration term for the Registered Name.
    </p>
    <p>
  Acknowledge and agree to be bound by the terms and conditions of the initial
  launch and general operations of the Registry TLD, including without
  limitation the Limited Industry Launch, the Sunrise Period, the Land Rush
  Period, the Sunrise Dispute Resolution Policy, the Premium Name Allocation
  Process, and the General Registration Period , and further to acknowledge that
  Registry Operator and the Registry Service Provider has no liability of any
  kind for any loss or liability resulting from the proceedings and processes
  relating to the Limited Industry Launch, the Sunrise Period, the Land Rush
  Period, the Sunrise Dispute Resolution Policy, the Premium Name Allocation
  Process, and the General Registration Period including, without limitation:
    </p>
    <p>
  (a) the ability or inability of a registrant to obtain a Registered Name
  during these periods,
    </p>
    <p>
  and (b) the results of any dispute made during the limited industry launch or
  over a Sunrise Registration.
    </p>
    <p>
  Acknowledge and agree that the Registry and Registry Services Provider, acting
  in consent with the Registry, reserves the right to deny, cancel or transfer
  any registration that it deems necessary, in its discretion (i) to protect the
  integrity and stability of the registry; (ii) to comply with all applicable
  laws, government rules or requirements, requests of law enforcement, in
  compliance with any dispute resolution process; (iii) to avoid any liability,
  civil or criminal, on the part of the Registry as well as its affiliates,
  subsidiaries, officers, directors, representatives, employees, and
  stockholders; (iv) for violations of the terms and conditions herein; or (v)
  to correct mistakes made by the Registry or any registrar in connection with a
  domain name registration, and the Registry also reserves the right to freeze a
  Registered Name during resolution of a dispute.{' '}
    </p>
    <p>
  Acknowledge and agree that they must comply with the requirements, standards,
  policies, procedures and practices set forth in the dotMobi Style Guide
  (www.mtld.mobi) and consent to the monitoring of the website as described in
  the dotMobi Style Guide monitoring guidelines (www.mtld.mobi) for compliance
  with the Style Guide. Furthermore, Registrant acknowledges and agrees that
  this Style Guide is subject to modification by the Registry with any such
  changes appearing at the previously designated URL, and that Registrant must
  promptly comply with any such changes in the time allotted.{' '}
    </p>
    <p>
  Acknowledge and agree that Proxy or Proxy Registrations will not be allowed
  during the Sunrise Period, the Limited Industry Launch and the Premium Name
  Allocation and Auction Period, and in such an instance will constitute a
  material breach to this contract.{' '}
    </p>
    <p>
  <a href="/terms-conditions">Back to Terms and Conditions</a>
    </p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      